import RefappBanner from './components/refapp-banner.vue';
import RefappBannerProvider from './components/base/provider.vue';

export default {
  install(app) {
    const components = [RefappBanner, RefappBannerProvider];
    components.forEach((c) => app.component(c.name, c));
  },
};
